<template>
  <div class="loading-page">
    <!-- 主内容区 -->
    <div class="loading-container">
      <!-- 顶部标题区域 -->
      <div class="loading-header">
        <div class="logo-icon">
          <svg t="1768200578733" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="4802" width="48" height="48">
            <path
              d="M856.3 64.5H167.7c-57 0-103.3 46.2-103.3 103.3v688.5c0 57 46.2 103.3 103.3 103.3h688.5c57 0 103.3-46.2 103.3-103.3V167.7c0-57-46.2-103.2-103.2-103.2zM250.6 533.4C318.1 506.1 359 469 381.3 413.2h-68.8c-23.5 0-44 1.2-58.8 3.7v-39.6c13.6 2.5 32.8 3.7 57 3.7h79.9c4.3-22.3 5-27.2 6.2-62.5h-64.4c-11.7 16.7-21.7 28.5-42.1 48.3-10.5-11.8-13.6-14.9-27.3-22.9 41.5-34 65.7-69.3 78-115.2l37.2 10.5c-2.5 4.3-3.1 4.9-5 9.9-6.2 11.8-11.1 22.3-19.2 36.6h118.3c24.8 0 42.7-1.3 57.6-3.7v39.6c-17.3-2.5-33.5-3.1-56.4-3.1H432c-1.9 37.8-2.5 39.6-6.2 62.5H489c23.6 0 40.3-1.2 55.7-3.7v39.6c-15.5-2.5-32.8-3.7-55.1-3.7h-72.5c-1.2 3.7-1.2 3.7-3.1 9.3 31.6 14.9 79.9 42.1 118.3 66.9l-21.7 32.8c-35.9-29.7-58.2-44.6-108.4-72.5-26 48.3-65 83.6-125.7 113.4-6.7-11.8-12.2-18.6-25.9-29.7z m423.7 261.9v-29.7H384.4v29.7h-41.5c2.5-15.5 3.7-34.6 3.7-63.1V602.7c0-34.1-0.6-50.2-2.5-68.1 19.8 1.9 36.5 2.5 66.9 2.5h236.6c30.4 0 46.5-0.6 66.9-2.5-1.8 19.2-2.5 32.2-2.5 68.1v129.5c0 31 1.2 47 3.7 63.1h-41.4z m99.1-298.5c-15.5-1.9-27.9-2.5-50.2-2.5H612.9c-22.9 0-35.3 0.6-51.4 2.5 1.9-16.7 2.5-26.6 2.5-45.8V327.2c0-20.5-0.6-33.5-2.5-50.8 15.5 1.8 27.9 2.5 51.4 2.5h109c24.2 0 35.9-0.7 51.4-2.5-1.9 15.5-2.5 29.1-2.5 50.1v122c0.1 20.5 0.7 33.5 2.6 48.3z"
              fill="#ffffff" p-id="4803"></path>
            <path d="M601.2 312.3h131.9v149.3H601.2zM384.4 571.1h289.9v61.3H384.4zM384.4 665.3h289.9v66.3H384.4z"
              fill="#ffffff" p-id="4804"></path>
          </svg>
        </div>
        <h1 class="title">智课通管理系统</h1>
        <p class="subtitle">AI赋能智慧课纲管理平台</p>
      </div>

      <!-- 加载内容区域 -->
      <div class="loading-content">
        <!-- 加载动画区域 -->
        <div class="loading-section">
          <!-- 环形加载器 -->
          <div class="loader">
            <div class="loader-ring"></div>
            <div class="loader-ring"></div>
            <div class="loader-ring"></div>
            <div class="loader-text">正在获取权限...</div>
          </div>
        </div>

        <!-- 状态信息 -->
        <div class="status-section">
          <transition name="fade" mode="out-in">
            <div :key="statusText" class="status-item">
              <i :class="statusIcon" class="status-icon"></i>
              <span class="status-text">{{ statusText }}</span>
            </div>
          </transition>
        </div>

        <!-- 进度条 -->
        <div class="progress-section">
          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: progressWidth + '%' }"></div>
          </div>
          <span class="progress-text">{{ progressText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAjUserDetailsRefresh } from '../../api/api';

export default {
  name: 'LoadingPage',
  data() {
    return {
      progress: 0,
      statusIndex: 0,
      statusTexts: [
        '正在验证用户身份...',
        '正在获取权限信息...',
        '正在加载菜单配置...',
        '正在初始化系统...',
        '即将进入系统...'
      ],
      statusIcons: [
        'el-icon-user',
        'el-icon-key',
        'el-icon-menu',
        'el-icon-setting',
        'el-icon-check'
      ]
    };
  },
  computed: {
    statusText() {
      return this.statusTexts[this.statusIndex];
    },
    statusIcon() {
      return this.statusIcons[this.statusIndex];
    },
    progressWidth() {
      return this.progress;
    },
    progressText() {
      return `${this.progress}%`;
    }
  },
  created() {
    // 检查是否已登录
    const token = localStorage.getItem('zhikeTong_token');
    if (!token) {
      this.$router.push('/dologin');
      return;
    }

    // 开始加载流程
    this.startLoading();
  },
  methods: {
    // 开始加载流程
    async startLoading() {
      // 进度条动画
      const progressTimer = setInterval(() => {
        if (this.progress < 90) {
          this.progress += Math.random() * 10;
        }
      }, 200);

      // 状态文字切换
      const statusTimer = setInterval(() => {
        if (this.statusIndex < this.statusTexts.length - 1) {
          this.statusIndex++;
        }
      }, 400);

      try {
        // 获取用户权限信息
        const res = await getAjUserDetailsRefresh();

        if (res && res.status === 200) {
          // 权限获取成功
          const authList = res.data.ajRoleAuthList;
          localStorage.setItem('zhikeTong_authRoter', JSON.stringify(authList));

          // 清除定时器
          clearInterval(progressTimer);
          clearInterval(statusTimer);

          // 完成进度
          this.progress = 100;
          this.statusIndex = this.statusTexts.length - 1;

          // 根据权限路由跳转到对应页面
          setTimeout(() => {
            this.navigateByRole(authList);
          }, 500);
        } else {
          throw new Error(res?.msg || '获取权限失败');
        }
      } catch (error) {
        console.error('加载权限失败:', error);
        clearInterval(progressTimer);
        clearInterval(statusTimer);

        this.$message.error('获取权限失败，请重新登录');
        this.$router.push('/dologin');
      }
    },

    // 根据权限跳转到不同页面
    navigateByRole(authList) {
      if (!authList || authList.length === 0) {
        this.$message.warning('暂无权限，请联系管理员');
        this.$router.push('/dologin');
        return;
      }

      // 获取保存的跳转路径
      const savedPath = localStorage.getItem('zhikeTong_path');

      // 判断是否有保存的路径且在权限内
      if (savedPath) {
        const hasPermission = this.checkPathInAuth(savedPath, authList);
        if (hasPermission) {
          this.$router.push(savedPath);
          return;
        }
      }

      // 根据角色权限跳转到第一个有权限的页面
      const firstRoute = this.getFirstAccessibleRoute(authList);
      if (firstRoute) {
        this.$router.push(firstRoute);
      } else {
        this.$message.warning('暂无访问权限');
        this.$router.push('/dologin');
      }
    },

    // 检查路径是否在权限列表中
    checkPathInAuth(path, authList) {
      // 移除 /Home 前缀
      const simplePath = path.replace('/Home/', '');

      for (const item of authList) {
        // 检查父级
        if (item.authRemark) {
          const parentRemark = item.authRemark.replace('/Home/', '');
          if (parentRemark === simplePath) return true;
        }

        // 检查子级
        if (item.children && item.children.length > 0) {
          for (const child of item.children) {
            if (child.authRemark) {
              const childRemark = child.authRemark.replace('/Home/', '');
              if (childRemark === simplePath) return true;
            }
          }
        }
      }
      return false;
    },

    // 获取第一个可访问的路由
    getFirstAccessibleRoute(authList) {
      for (const item of authList) {
        // 如果有子级，取第一个子级
        if (item.children && item.children.length > 0) {
          const firstChild = item.children[0];
          if (firstChild.authUrl) {
            return firstChild.authUrl;
          }
        }
        // 否则取父级
        if (item.authUrl) {
          return item.authUrl;
        }
      }
      return null;
    }
  }
};
</script>

<style scoped>
/* 页面容器 */
.loading-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-image: linear-gradient(45deg, #2c3e50, #27ae60, #2980b9, #8e44ad);
  animation: bganimation 15s infinite;
}

@keyframes bganimation {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* 主内容区 - 与登录页一致 */
.loading-container {
  width: 400px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  position: relative;
  z-index: 1;
}

/* 顶部标题区域 */
.loading-header {
  background: linear-gradient(135deg, #409EFF 0%, #6c42e8 100%);
  padding: 30px 20px;
  text-align: center;
  color: #fff;
}

.logo-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
}

.title {
  font-size: 22px;
  margin: 0 0 8px;
  font-weight: 600;
}

.subtitle {
  font-size: 14px;
  opacity: 0.9;
  margin: 0;
}

/* 加载内容区域 */
.loading-content {
  padding: 30px 20px;
  background: #f5f7fa;
}

/* 加载动画区域 */
.loading-section {
  margin-bottom: 30px;
}

.loader {
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.loader-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-top-color: rgba(64, 158, 255, 0.5);
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

.loader-ring:nth-child(2) {
  width: 90%;
  height: 90%;
  border-top-color: rgba(108, 66, 232, 0.5);
  animation-duration: 1.2s;
  animation-direction: reverse;
}

.loader-ring:nth-child(3) {
  width: 70%;
  height: 70%;
  border-top-color: rgba(103, 194, 58, 0.5);
  animation-duration: 0.9s;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loader-text {
  position: absolute;
  bottom: -30px;
  font-size: 13px;
  color: #666;
  white-space: nowrap;
}

/* 状态信息 */
.status-section {
  margin-bottom: 25px;
  height: 24px;
}

.status-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.status-icon {
  font-size: 16px;
  color: #67c23a;
}

.status-text {
  font-size: 14px;
  color: #333;
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* 进度条 */
.progress-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: #e6e6e6;
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #409EFF, #6c42e8, #67c23a);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 12px;
  color: #999;
  text-align: right;
}
</style>
